import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { DatasourceLineageSubplaceRouter, DatasourceLineageSubplaceRouterProps } from './DatasourceLineageSubplace';

export type EmbeddableDatasourceSubplaceProps = VizPortalDataCatalogProviderProps & DatasourceLineageSubplaceRouterProps;

export function EmbeddableDatasourceSubplaceWithoutRouter(props: EmbeddableDatasourceSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <DatasourceLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
